import { render, staticRenderFns } from "./FileMapperTable.vue?vue&type=template&id=cdadc378&"
import script from "./FileMapperTable.vue?vue&type=script&lang=ts&"
export * from "./FileMapperTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports